import { createFileRoute } from "@tanstack/react-router";
import { ApiKeys } from "../../../features/settings/apikeys";

export const Route = createFileRoute("/_authed/$org/settings/apikeys")({ component: ApiKeysPage });

function ApiKeysPage() {
  return <ApiKeys org={Route.useParams().org} />;
}
